'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var reselect = require('reselect');
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var _regeneratorRuntime = _interopDefault(require('@babel/runtime/regenerator'));
var effects = require('redux-saga/effects');
var ssrConfig = require('@engaging-tech/ssr-config');
var ga = _interopDefault(require('react-ga'));
var ReactPixel = _interopDefault(require('react-facebook-pixel'));
var TagManager = _interopDefault(require('react-gtm-module'));
var Insight = _interopDefault(require('react-linkedin-insight'));
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var routing = require('@engaging-tech/routing');
var React = require('react');
var React__default = _interopDefault(React);
var reactRedux = require('react-redux');
var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var components = require('@engaging-tech/components');
var styled = _interopDefault(require('styled-components'));

var types = {
  INITIALISE: "[Third Party/Analytics] Initialise",
  PAGE_VIEW: "[Third Party/Analytics] Page View",
  PAGE_VIEW_SUCCESS: "[Third Party/Analytics] Page View Success",
  PAGE_VIEW_FAIL: "[Third Party/Analytics] Page View Fail"
};
var initialise = function initialise() {
  return {
    type: types.INITIALISE
  };
};
var pageView = function pageView() {
  return {
    type: types.PAGE_VIEW
  };
};
var pageViewSuccess = function pageViewSuccess() {
  return {
    type: types.PAGE_VIEW_SUCCESS
  };
};
var pageViewFail = function pageViewFail() {
  return {
    type: types.PAGE_VIEW_FAIL
  };
};

var analytics_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  types: types,
  initialise: initialise,
  pageView: pageView,
  pageViewSuccess: pageViewSuccess,
  pageViewFail: pageViewFail
});

var types$1 = {
  INITIALISE: "[Third Party/Marketing] Initialise"
};
var initialise$1 = function initialise() {
  return {
    type: types$1.INITIALISE
  };
};

var marketing_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  types: types$1,
  initialise: initialise$1
});

var types$2 = {
  INITIALISE: "[Third Party/Functional] Initialise"
};
var initialise$2 = function initialise() {
  return {
    type: types$2.INITIALISE
  };
};

var functional_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  types: types$2,
  initialise: initialise$2
});

var types$3 = {
  INITIALISE: "[Third Party/Performance] Initialise"
};
var initialise$3 = function initialise() {
  return {
    type: types$3.INITIALISE
  };
};

var performance_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  types: types$3,
  initialise: initialise$3
});

var types$4 = {
  INITIALISE: "[Third Party Cookies] Initialise",
  INITIALISE_FAIL: "[Third Party Cookies] Initialise Fail",
  GET_CONSENT: "[Third Party Cookies] Get Consent",
  GET_CONSENT_COMPLETE: "[Third Party Cookies] Get Consent Complete",
  SET_CONSENT: "[Third Party Cookies] Set Consent",
  SET_HAS_CONSENTED: "[Third Party Cookies] Set Has Consented",
  SET_CLEAR_CONSENT: "[Third Party Cookies] Set Clear Consent"
};
var initialise$4 = function initialise() {
  return {
    type: types$4.INITIALISE
  };
};
var initialiseFail = function initialiseFail(cookieType) {
  return {
    type: types$4.INITIALISE_FAIL,
    payload: cookieType
  };
};
var getConsent = function getConsent() {
  return {
    type: types$4.GET_CONSENT
  };
};
var getConsentComplete = function getConsentComplete(consent) {
  return {
    type: types$4.GET_CONSENT_COMPLETE,
    payload: consent
  };
};
var setConsent = function setConsent(_ref) {
  var cookieType = _ref.cookieType,
    consent = _ref.consent;
  return {
    type: types$4.SET_CONSENT,
    payload: {
      cookieType: cookieType,
      consent: consent
    }
  };
};
var setHasConsented = function setHasConsented(hasConsented) {
  return {
    type: types$4.SET_HAS_CONSENTED,
    payload: hasConsented
  };
};
var setClearConsent = function setClearConsent() {
  return {
    type: types$4.SET_CLEAR_CONSENT
  };
};

var Actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  types: types$4,
  initialise: initialise$4,
  initialiseFail: initialiseFail,
  getConsent: getConsent,
  getConsentComplete: getConsentComplete,
  setConsent: setConsent,
  setHasConsented: setHasConsented,
  setClearConsent: setClearConsent,
  analytics: analytics_actions,
  marketing: marketing_actions,
  functional: functional_actions,
  performance: performance_actions
});

var thirdPartyState = function thirdPartyState(state) {
  return state.thirdParty;
};

/* eslint-disable-next-line import/prefer-default-export */
var getHasConsented = reselect.createSelector(thirdPartyState, function (state) {
  return state.consent && state.consent.analytics;
});

var analytics_selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getHasConsented: getHasConsented
});

var thirdPartyState$1 = function thirdPartyState(state) {
  return state.thirdParty;
};

/* eslint-disable-next-line import/prefer-default-export */
var getHasConsented$1 = reselect.createSelector(thirdPartyState$1, function (state) {
  return state.consent && state.consent.marketing;
});

var marketing_selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getHasConsented: getHasConsented$1
});

var thirdPartyState$2 = function thirdPartyState(state) {
  return state.thirdParty;
};

/* eslint-disable-next-line import/prefer-default-export */
var getHasConsented$2 = reselect.createSelector(thirdPartyState$2, function (state) {
  return state.consent && state.consent.functional;
});

var functional_selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getHasConsented: getHasConsented$2
});

var thirdPartyState$3 = function thirdPartyState(state) {
  return state.thirdParty;
};

/* eslint-disable-next-line import/prefer-default-export */
var getHasConsented$3 = reselect.createSelector(thirdPartyState$3, function (state) {
  return state.consent && state.consent.performance;
});

var performance_selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getHasConsented: getHasConsented$3
});

var thirdPartyState$4 = function thirdPartyState(state) {
  return state.thirdParty;
};
var getHasConsented$4 = reselect.createSelector(thirdPartyState$4, function (state) {
  return state.hasConsented;
});
var getConsent$1 = reselect.createSelector(thirdPartyState$4, function (state) {
  return state.consent;
});

var Selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getHasConsented: getHasConsented$4,
  getConsent: getConsent$1,
  analytics: analytics_selectors,
  marketing: marketing_selectors,
  functional: functional_selectors,
  performance: performance_selectors
});

var cookieTypes = {
  all: "all",
  marketing: "marketing",
  analytics: "analytics",
  functional: "functional"
  // performance: "performance"
};

var consentCategories = Object.keys(cookieTypes).filter(function (type) {
  return cookieTypes[type] !== cookieTypes.all;
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var setAllConsent = function setAllConsent(consent) {
  return consentCategories.reduce(function (acc, cur) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, consent));
  }, {});
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var initialState = {
  consent: null,
  hasConsented: false
};
var setConsent$1 = function setConsent(state, _ref) {
  var cookieType = _ref.cookieType,
    consent = _ref.consent;
  return cookieType === cookieTypes.all ? setAllConsent(consent) : _objectSpread$1(_objectSpread$1({}, state.consent), {}, _defineProperty({}, cookieType, consent));
};
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case types$4.SET_CONSENT:
      localStorage.setItem("consent", JSON.stringify(action.payload));
      return _objectSpread$1(_objectSpread$1({}, state), {}, {
        consent: setConsent$1(state, action.payload)
      });
    case types$4.GET_CONSENT_COMPLETE:
      return _objectSpread$1(_objectSpread$1({}, state), {}, {
        consent: action.payload
      });
    case types$4.SET_HAS_CONSENTED:
      localStorage.setItem("hasConsented", JSON.stringify(action.payload));
      return _objectSpread$1(_objectSpread$1({}, state), {}, {
        hasConsented: action.payload
      });
    case types$4.SET_CLEAR_CONSENT:
      localStorage.setItem("consent", JSON.stringify(null));
      localStorage.setItem("hasConsented", JSON.stringify(false));
      return _objectSpread$1(_objectSpread$1({}, state), {}, {
        consent: null,
        hasConsented: false
      });
    default:
      return state;
  }
};

var CONSENT_KEY = "cookieConsent";
var HAS_CONSENTED_KEY = "hasConsentedCookies";
var consent;
var setConsent$2 = function setConsent(consentValue) {
  if (!consentValue) {
    consent = setAllConsent(true);
  } else {
    consent = consentValue;
  }
};
var saveConsent = function saveConsent(consentSetting) {
  setConsent$2(consentSetting);
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consentSetting));
};
var saveHasConsented = function saveHasConsented(value) {
  localStorage.setItem(HAS_CONSENTED_KEY, JSON.stringify({
    value: value
  }));
};

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(initialiseSaga),
  _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(setConsentSaga),
  _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(setHasConsentedSaga),
  _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(saga);
function initialiseByCategory(consent) {
  var categories = consentCategories.filter(function (category) {
    return consent[category];
  });
  return categories.map(function (category) {
    return effects.put(Actions[category].initialise());
  });
}
function initialiseSaga() {
  var hasConsented, consent, initialisers;
  return _regeneratorRuntime.wrap(function initialiseSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return effects.select(getHasConsented$4);
      case 2:
        hasConsented = _context.sent;
        if (!hasConsented) {
          _context.next = 14;
          break;
        }
        _context.next = 6;
        return effects.select(getConsent$1);
      case 6:
        consent = _context.sent;
        _context.next = 9;
        return effects.call(initialiseByCategory, consent);
      case 9:
        initialisers = _context.sent;
        _context.next = 12;
        return effects.all(initialisers);
      case 12:
        _context.next = 16;
        break;
      case 14:
        _context.next = 16;
        return effects.put(initialiseFail());
      case 16:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
function setConsentSaga() {
  var consent;
  return _regeneratorRuntime.wrap(function setConsentSaga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return effects.select(getConsent$1);
      case 2:
        consent = _context2.sent;
        _context2.next = 5;
        return effects.call(saveConsent, consent);
      case 5:
      case "end":
        return _context2.stop();
    }
  }, _marked2);
}
function setHasConsentedSaga() {
  var hasConsented;
  return _regeneratorRuntime.wrap(function setHasConsentedSaga$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return effects.select(getHasConsented$4);
      case 2:
        hasConsented = _context3.sent;
        _context3.next = 5;
        return effects.call(saveHasConsented, hasConsented);
      case 5:
        if (!hasConsented) {
          _context3.next = 8;
          break;
        }
        _context3.next = 8;
        return effects.put(initialise$4());
      case 8:
      case "end":
        return _context3.stop();
    }
  }, _marked3);
}
function saga() {
  return _regeneratorRuntime.wrap(function saga$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return effects.takeLatest(types$4.SET_CONSENT, setConsentSaga);
      case 2:
        _context5.next = 4;
        return effects.takeLatest(types$4.SET_HAS_CONSENTED, setHasConsentedSaga);
      case 4:
        _context5.next = 6;
        return effects.takeLatest(types$4.INITIALISE, initialiseSaga);
      case 6:
      case "end":
        return _context5.stop();
    }
  }, _marked5);
}

var DEFAULT_PATH = typeof window !== "undefined" && window.location.pathname + window.location.search;
var GA_KEY = function GA_KEY() {
  return ssrConfig.getConfig().keys.ga;
};

/**
 *
 * @param {*} provider An analytics provider. Defaults to Google Analytics.
 * @param {string} trackingCode The unique identifier used by the provider. Defaults to the
 * Engaging Works GA ID.
 */
var initialise$5 = function initialise() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ga;
  var trackingCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GA_KEY();
  provider.initialize(trackingCode);
};

/**
 * Records a page view event with the analytics provider.
 * @param {*} provider An analytics provider. Defaults to Google Analytics.
 */
var pageView$1 = function pageView() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_PATH;
  var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ga;
  provider.pageview(path);
};

var Ga = /*#__PURE__*/Object.freeze({
  __proto__: null,
  initialise: initialise$5,
  pageView: pageView$1
});

var PIXEL_KEY = function PIXEL_KEY() {
  return ssrConfig.getConfig().keys.facebookPixel;
};
var DEFAULT_PATH$1 = typeof window !== "undefined" && window.location.pathname + window.location.search;

/**
 *
 * @param {*} provider An analytics provider. Defaults to Facebook Pixel.
 * @param {string} trackingCode The unique identifier used by the provider. Defaults to the
 * Engaging Works Pixel ID.
 */
var initialise$6 = function initialise() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ReactPixel;
  var trackingCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PIXEL_KEY();
  provider.init(trackingCode);
};

/**
 * Records a page view event with the analytics provider.
 * @param {*} provider An analytics provider. Defaults to Facebook Pixel.
 */
var pageView$2 = function pageView() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_PATH$1;
  var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ReactPixel;
  provider.pageView(path);
};

var Pixel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  initialise: initialise$6,
  pageView: pageView$2
});

var GTM_KEY = function GTM_KEY() {
  return ssrConfig.getConfig().keys.gtmId;
};

/**
 *
 * @param {*} provider An GTM provider. Defaults to Google Tag Manager.
 * @param {string} trackingCode The unique identifier used by the provider. Defaults to the
 * Engaging Works GTM ID.
 */
var initialise$7 = function initialise() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TagManager;
  var trackingCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GTM_KEY();
  provider.initialize({
    gtmId: trackingCode
  });
};
var test = false;

var GTM = /*#__PURE__*/Object.freeze({
  __proto__: null,
  initialise: initialise$7,
  test: test
});

var ANALYTICS_PROVIDERS = [Ga, Pixel, GTM];
var ANALYTICS_PROVIDERS_PAGEVIEW = [Ga, Pixel];
var initialise$8 = function initialise() {
  var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ANALYTICS_PROVIDERS;
  providers.forEach(function (provider) {
    return provider.initialise();
  });
};
var pageView$3 = function pageView() {
  var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ANALYTICS_PROVIDERS_PAGEVIEW;
  var url = window && window.location && window.location.pathname + window.location.search;
  providers.forEach(function (provider) {
    return provider.pageView(url);
  });
};

var _marked$1 = /*#__PURE__*/_regeneratorRuntime.mark(initialiseSaga$1),
  _marked2$1 = /*#__PURE__*/_regeneratorRuntime.mark(pageViewSaga),
  _marked3$1 = /*#__PURE__*/_regeneratorRuntime.mark(saga$1);
var isProd = function isProd() {
  return ssrConfig.getConfig().isProd;
};
function initialiseSaga$1() {
  return _regeneratorRuntime.wrap(function initialiseSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return effects.call(initialise$8);
      case 2:
        _context.next = 4;
        return effects.put(pageView());
      case 4:
      case "end":
        return _context.stop();
    }
  }, _marked$1);
}
function pageViewSaga() {
  var hasConsented;
  return _regeneratorRuntime.wrap(function pageViewSaga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return effects.select(getHasConsented);
      case 2:
        hasConsented = _context2.sent;
        if (!(hasConsented && isProd())) {
          _context2.next = 17;
          break;
        }
        _context2.prev = 4;
        _context2.next = 7;
        return effects.call(pageView$3);
      case 7:
        _context2.next = 9;
        return effects.put(pageViewSuccess());
      case 9:
        _context2.next = 15;
        break;
      case 11:
        _context2.prev = 11;
        _context2.t0 = _context2["catch"](4);
        _context2.next = 15;
        return effects.put(pageViewFail());
      case 15:
        _context2.next = 19;
        break;
      case 17:
        _context2.next = 19;
        return effects.put(pageViewFail());
      case 19:
      case "end":
        return _context2.stop();
    }
  }, _marked2$1, null, [[4, 11]]);
}
function saga$1() {
  return _regeneratorRuntime.wrap(function saga$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return effects.takeLatest(types.INITIALISE, initialiseSaga$1);
      case 2:
        _context3.next = 4;
        return effects.takeLatest(types.PAGE_VIEW, pageViewSaga);
      case 4:
      case "end":
        return _context3.stop();
    }
  }, _marked3$1);
}

/* eslint-disable import/prefer-default-export */
var INSIGHT_KEY = function INSIGHT_KEY() {
  return ssrConfig.getConfig().keys.linkedin;
};

/**
 * @param {*} provider A marketing provider. Defaults to LinkedIn Insight.
 * @param {string} trackingCode The unique identifier used by the provider. Defaults to the
 * Engaging Works LinkedIn partner ID.
 */
var initialise$9 = function initialise() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Insight;
  var trackingCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INSIGHT_KEY();
  return provider.init(trackingCode);
};

var _marked$2 = /*#__PURE__*/_regeneratorRuntime.mark(initialiseSaga$2),
  _marked2$2 = /*#__PURE__*/_regeneratorRuntime.mark(saga$2);
function initialiseSaga$2() {
  return _regeneratorRuntime.wrap(function initialiseSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return effects.call(initialise$9);
      case 2:
      case "end":
        return _context.stop();
    }
  }, _marked$2);
}
function saga$2() {
  return _regeneratorRuntime.wrap(function saga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return effects.takeLatest(types$1.INITIALISE, initialiseSaga$2);
      case 2:
      case "end":
        return _context2.stop();
    }
  }, _marked2$2);
}

var _marked$3 = /*#__PURE__*/_regeneratorRuntime.mark(initialiseSaga$3),
  _marked2$3 = /*#__PURE__*/_regeneratorRuntime.mark(saga$3);
function initialiseSaga$3() {
  return _regeneratorRuntime.wrap(function initialiseSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return null;
      case 2:
      case "end":
        return _context.stop();
    }
  }, _marked$3);
}
function saga$3() {
  return _regeneratorRuntime.wrap(function saga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return effects.takeLatest(types$2.INITIALISE, initialiseSaga$3);
      case 2:
      case "end":
        return _context2.stop();
    }
  }, _marked2$3);
}

var _marked$4 = /*#__PURE__*/_regeneratorRuntime.mark(initialiseSaga$4),
  _marked2$4 = /*#__PURE__*/_regeneratorRuntime.mark(saga$4);
function initialiseSaga$4() {
  return _regeneratorRuntime.wrap(function initialiseSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return null;
      case 2:
      case "end":
        return _context.stop();
    }
  }, _marked$4);
}
function saga$4() {
  return _regeneratorRuntime.wrap(function saga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return effects.takeLatest(types$3.INITIALISE, initialiseSaga$4);
      case 2:
      case "end":
        return _context2.stop();
    }
  }, _marked2$4);
}

var PageviewWrapper = function PageviewWrapper(_ref) {
  var onNavigate = _ref.onNavigate;
  var location = routing.useLocation();
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasMounted = _useState2[0],
    setHasMounted = _useState2[1];
  React.useEffect(function () {
    // Don't fire an analytics event on render
    if (hasMounted) onNavigate();else setHasMounted(true);
  }, [location, onNavigate, hasMounted]);
  return null;
};
var mapDispatch = function mapDispatch(dispatch) {
  return {
    onNavigate: function onNavigate() {
      return dispatch(pageView());
    }
  };
};
var PageviewTracker = reactRedux.connect(null, mapDispatch)(PageviewWrapper);

var Toggle = function Toggle(_ref) {
  var _ref$hasConsented = _ref.hasConsented,
    hasConsented = _ref$hasConsented === void 0 ? false : _ref$hasConsented,
    category = _ref.category,
    giveConsent = _ref.giveConsent,
    noLabel = _ref.noLabel,
    outerBoxStyle = _ref.outerBoxStyle,
    toggleStyle = _ref.toggleStyle;
  return /*#__PURE__*/React__default.createElement(components.Box, _extends({
    mb: 3
  }, outerBoxStyle, {
    "data-cy": "cookie-toggle-container-".concat(category)
  }), /*#__PURE__*/React__default.createElement(components.Toggle, _extends({
    id: "toggle-component",
    size: 50,
    initialState: hasConsented,
    disabled: category === "functional",
    onChange: function onChange() {
      return giveConsent(!hasConsented);
    },
    "data-cy": "cookie-toggle-hidden-input-".concat(category),
    label: !noLabel ? "".concat(category, " cookies are ").concat(hasConsented ? "enabled" : "disabled") : null
  }, toggleStyle)));
};

var ConsentToggles = function ConsentToggles() {
  return consentCategories.map(function (category) {
    var mapState = function mapState(state) {
      return {
        hasConsented: Selectors[category].getHasConsented(state)
      };
    };
    var mapDispatch = function mapDispatch(dispatch) {
      return {
        giveConsent: function giveConsent(consent) {
          return dispatch(setConsent({
            cookieType: category,
            consent: consent
          }));
        }
      };
    };
    return reactRedux.connect(mapState, mapDispatch)(Toggle);
  });
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var outLineButtonProps = {
  color: "#173C5A",
  backgroundColor: "transparent",
  border: "2px solid #173C5A",
  borderRadius: "4px",
  "&:hover": {
    color: "#14344e",
    border: "2px solid #14344e"
  },
  "&:active": {
    color: "#14344e",
    border: "2px solid #14344e"
  },
  "&:focus": {
    color: "#14344e",
    border: "2px solid #14344e"
  },
  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed"
  }
};
var standardButtonProps = {
  color: "rgba(255, 255, 255, 0.87)",
  backgroundColor: "#173C5A",
  "&:hover": {
    backgroundColor: "#153752"
  },
  "&:active": {
    backgroundColor: "#153752"
  },
  "&:focus": {
    backgroundColor: "#153752"
  },
  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed"
  }
};
var LEGAL_PAGE_URL = "legal";
var StyledImage = styled.img.withConfig({
  displayName: "Banner__StyledImage",
  componentId: "sc-1qjep1x-0"
})(["height:44px;width:44px;@media (max-width:780px){width:28px;height:28px;}"]);
var IconWrapper = styled(components.Box).withConfig({
  displayName: "Banner__IconWrapper",
  componentId: "sc-1qjep1x-1"
})(["position:absolute;top:16px;left:24px;"]);
var OuterCard = styled(components.Card).withConfig({
  displayName: "Banner__OuterCard",
  componentId: "sc-1qjep1x-2"
})(["position:relative;border-radius:10px;overflow:scroll;max-height:95%;"]);
var ScrollOverLay = styled(components.Overlay).withConfig({
  displayName: "Banner__ScrollOverLay",
  componentId: "sc-1qjep1x-3"
})(["position:relative;border-radius:10px;"]);
var SettingsText = {
  marketing: {
    name: "Marketing",
    description: "Used by third party companies like Google and Facebook Pixel for analytics and service improvement."
  },
  analytics: {
    name: "Analytics",
    description: "These are used for site analytics and service improvement for the site."
  },
  functional: {
    name: "Functional",
    description: "Used for storing your user account ID when you’re logged in and tracking your completed Happiness survey results."
  },
  performance: {
    name: "Performance",
    description: "This is used for site analytics and service improvements for the site."
  }
};
var Settings = function Settings(_ref) {
  var giveConsentToAll = _ref.giveConsentToAll,
    saveSettings = _ref.saveSettings;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(components.Text, {
    color: "#7F7F7F",
    fontSize: [2, 3],
    lineHeight: "20px",
    textAlign: "center",
    width: 1
  }, "WorkL uses both own & third party cookies to offer you the best browsing experience and makes our service better. You can toggle the settings below:"), /*#__PURE__*/React__default.createElement(components.Box, {
    width: 1,
    mt: 2
  }, ConsentToggles().map(function (Toggle, index) {
    var consentCategory = consentCategories[index];
    return _objectSpread$2({
      Toggle: Toggle,
      consentCategory: consentCategory
    }, SettingsText[consentCategory]);
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }).map(function (_ref2, index) {
    var Toggle = _ref2.Toggle,
      consentCategory = _ref2.consentCategory,
      name = _ref2.name,
      description = _ref2.description;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default.createElement(components.Flex, {
        key: index,
        mt: 4
      }, /*#__PURE__*/React__default.createElement(components.Box, {
        width: 1
      }, /*#__PURE__*/React__default.createElement(components.Text, {
        display: "block",
        width: 1,
        fontWeight: "bold",
        mb: 3
      }, name), /*#__PURE__*/React__default.createElement(components.Text, {
        display: "block",
        width: 1,
        fontSize: [1, 2],
        color: "#7F7F7F"
      }, description)), /*#__PURE__*/React__default.createElement(Toggle, {
        key: consentCategory,
        id: "toggle-".concat(index),
        category: consentCategory,
        noLabel: true,
        outerBoxStyle: {
          width: "auto"
        },
        toggleStyle: {
          mr: 0,
          onColour: "#173C5A"
        }
      }))
    );
  })), /*#__PURE__*/React__default.createElement(components.Flex, {
    mt: [4, 5],
    flexDirection: "row",
    justifyContent: "space-between",
    width: 1 / 1
  }, /*#__PURE__*/React__default.createElement(components.Button, _extends({}, outLineButtonProps, {
    elevation: 0,
    fontSize: [1, 3],
    onClick: saveSettings,
    width: ["114px", "146px"],
    ml: 2,
    "data-cy": "cookie-notification-save-settings-button"
  }), "Save Settings"), /*#__PURE__*/React__default.createElement(components.Button, _extends({}, standardButtonProps, {
    elevation: 0,
    fontSize: [1, 3],
    onClick: function onClick() {
      return giveConsentToAll(true);
    },
    width: ["114px", "146px"],
    "data-cy": "cookie-notification-accept-all-button"
  }), "Accept All")));
};
var DefaultView = function DefaultView(_ref3) {
  var giveConsentToAll = _ref3.giveConsentToAll,
    setDisplaySettings = _ref3.setDisplaySettings;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(components.Text, {
    color: "#7F7F7F",
    fontSize: [2, 3],
    lineHeight: "20px",
    textAlign: "center",
    width: 1
  }, "We use cookies to help run our service and to improve our functionality to give you a better experience. For further information please read our", " ", /*#__PURE__*/React__default.createElement(routing.Link, {
    to: "/legal/cookies"
  }, /*#__PURE__*/React__default.createElement(components.Text, {
    color: "#173C5A",
    fontSize: [2, 3],
    fontWeight: "600"
  }, "Cookie Policy")), " ", "and", " ", /*#__PURE__*/React__default.createElement(routing.Link, {
    to: "/legal/privacy-policy"
  }, /*#__PURE__*/React__default.createElement(components.Text, {
    color: "#173C5A",
    fontSize: [2, 3],
    fontWeight: "600"
  }, "Privacy Policy")), ". Your current cookie settings can be changed here at any time."), /*#__PURE__*/React__default.createElement(components.Flex, {
    mt: [4, 5],
    flexDirection: "row",
    justifyContent: "space-between",
    width: 1 / 1
  }, /*#__PURE__*/React__default.createElement(components.Button, _extends({}, outLineButtonProps, {
    elevation: 0,
    fontSize: [1, 3],
    onClick: function onClick() {
      return setDisplaySettings(true);
    },
    width: ["114px", "146px"],
    ml: 2,
    "data-cy": "cookie-notification-settings-button"
  }), "Cookie Settings"), /*#__PURE__*/React__default.createElement(components.Button, _extends({}, standardButtonProps, {
    elevation: 0,
    fontSize: [1, 3],
    onClick: function onClick() {
      return giveConsentToAll(true);
    },
    width: ["114px", "146px"],
    "data-cy": "cookie-notification-accept-button"
  }), "Accept")));
};
var Banner = function Banner(_ref4) {
  var hasConsented = _ref4.hasConsented,
    giveConsentToAll = _ref4.giveConsentToAll,
    _ref4$exceptions = _ref4.exceptions,
    exceptions = _ref4$exceptions === void 0 ? [] : _ref4$exceptions,
    saveSettings = _ref4.saveSettings,
    iconImage = _ref4.iconImage,
    updateConsentFromStorage = _ref4.updateConsentFromStorage,
    updateFunctionalConsent = _ref4.updateFunctionalConsent;
  var _useLocation = routing.useLocation(),
    pathname = _useLocation.pathname;
  var _useState = React.useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    displaySettings = _useState2[0],
    setDisplaySettings = _useState2[1];

  /**
   * Hides the cookie banner when viewing either the cookie policy
   * or privacy policy page. We've done this to allow users the
   * opportunity to read either policy before accepting/declining
   * consent.
   */
  React.useEffect(function () {
    updateFunctionalConsent();
    updateConsentFromStorage();
  });
  React.useEffect(function () {
    var keyDownHandler = function keyDownHandler(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        saveSettings();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return function () {
      document.removeEventListener("keydown", keyDownHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var isViewingException = React.useMemo(function () {
    return !!exceptions.concat([LEGAL_PAGE_URL]).find(function (exception) {
      return pathname.includes(exception);
    });
  }, [exceptions, pathname]);
  var isBannerVisible = function isBannerVisible() {
    return !hasConsented && !isViewingException && typeof "window" !== "undefined";
  }; // hide during server-side rendering & hydration

  return isBannerVisible() && /*#__PURE__*/React__default.createElement(ScrollOverLay, {
    onClick: function onClick() {
      return null;
    },
    bg: "rgba(0, 0, 0, 0.23)",
    justifyContent: "center",
    alignItems: "center",
    mb: 0
  }, /*#__PURE__*/React__default.createElement(components.Utils.DisableScroll, null), /*#__PURE__*/React__default.createElement(OuterCard, {
    flexDirection: "column",
    width: ["287px", "414px"],
    maxWidth: "414px",
    alignItems: "center",
    bg: "light.0",
    px: [3, 4],
    pb: [3, 4],
    pt: 4,
    "data-cy": "cookie-notification"
  }, iconImage && /*#__PURE__*/React__default.createElement(IconWrapper, {
    width: "auto"
  }, /*#__PURE__*/React__default.createElement(StyledImage, {
    alt: "cookie",
    src: iconImage,
    loading: "lazy"
  })), /*#__PURE__*/React__default.createElement(components.Text, {
    fontFamily: "Centra",
    mb: 5,
    fontSize: [3, 5],
    lineHeight: ["16px", "20px"],
    fontWeight: "800",
    color: "#212121",
    textAlign: "center",
    display: "block",
    width: 1
  }, displaySettings ? "Cookie Settings" : "This website uses cookies"), displaySettings && /*#__PURE__*/React__default.createElement(Settings, {
    giveConsentToAll: giveConsentToAll,
    saveSettings: saveSettings
  }), !displaySettings && /*#__PURE__*/React__default.createElement(DefaultView, {
    giveConsentToAll: giveConsentToAll,
    setDisplaySettings: setDisplaySettings
  })));
};

var mapState = function mapState(state) {
  return {
    hasConsented: getHasConsented$4(state)
  };
};
var mapDispatch$1 = function mapDispatch(dispatch) {
  return {
    giveConsentToAll: function giveConsentToAll() {
      dispatch(setConsent({
        cookieType: cookieTypes.all,
        consent: true
      }));
      dispatch(setHasConsented(true));
    },
    updateFunctionalConsent: function updateFunctionalConsent() {
      var functionalConsent = {
        cookieType: cookieTypes.functional,
        consent: true
      };
      dispatch(setConsent(functionalConsent));
    },
    updateConsentFromStorage: function updateConsentFromStorage() {
      var existingConsent = JSON.parse(localStorage.getItem("consent"));
      var existingHasConsented = JSON.parse(localStorage.getItem("hasConsented"));
      if (!existingConsent || !existingHasConsented) return;
      dispatch(setConsent({
        cookieType: existingConsent.cookieType,
        consent: true
      }));
      dispatch(setHasConsented(existingHasConsented));
    },
    saveSettings: function saveSettings() {
      return dispatch(setHasConsented(true));
    }
  };
};
var BannerContainer = reactRedux.connect(mapState, mapDispatch$1);
var ConsentBanner = BannerContainer(Banner);

exports.BannerContainer = BannerContainer;
exports.ConsentBanner = ConsentBanner;
exports.ConsentToggles = ConsentToggles;
exports.PageviewTracker = PageviewTracker;
exports.ThirdPartyActions = Actions;
exports.ThirdPartySelectors = Selectors;
exports.analyticsSaga = saga$1;
exports.consentCategories = consentCategories;
exports.cookieTypes = cookieTypes;
exports.functionalSaga = saga$3;
exports.marketingSaga = saga$2;
exports.performanceSaga = saga$4;
exports.thirdPartyReducer = reducer;
exports.thirdPartySaga = saga;
